import React, { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import Collapse from 'react-bootstrap/Collapse';
import UserInfo from "./UserInfo";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import {FaRegUserCircle} from "react-icons/fa";

const PodcasterUserItem = ({ user, selectUser }) => {
    useEffect(() => {
        console.log(user)
    }, []);

    return (
        <div className="mb-1 p-1 border-bottom">
            <Row className="">
                <Col md={6}>
                    <h6 className="mb-1">{user.first_name} {user.last_name}</h6>
                    <p className="text-muted small mb-2">{user.email}</p>
                </Col>
                <Col md={4}>
                    {user.is_active && (
                        <Badge bg="success">Active</Badge>
                    )}
                </Col>
                <Col md={2} className="text-end">
                    <Button size={'sm'} variant={'outline-primary'} onClick={() => selectUser(user)}>
                        <FaRegUserCircle />
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default PodcasterUserItem;